export default __webpack_public_path__ + "static/reward-2-4d15ba6ca5f922798fc2e1db197e7641.png";